export default {
  SET_ANALYTICS_CONFIGURATION(state, payload) {
    state.configuration = payload
  },
  SET_RFV_ANALYTICS_CONFIGURATIONS(state, payload) {
    state.rfvAnalyticConfigurations = payload
  },
  SET_ALL_ANALYTIC_PERIODS(state, payload) {
    state.allConfigurationPeriods = payload
  },
  SET_CLIENTS_METRICS(state, { key, payload }) {
    state.clientsMetrics[key] = payload
  },
  SET_PERIOD_MIGRATIONS(state, payload) {
    state.periodMigrations = payload
  },
  SET_CURRENT_PERIOD(state, period) {
    state.currentPeriod = period
  },
  SET_REFERENCE_PERIOD(state, period) {
    state.referencePeriod = period
  },
  SET_IS_FETCHING_ANALYTICS_CONFIGURATION(state, value) {
    state.isFetchingAnalyticsConfiguration = value
  },
  SET_IS_FETCHING_ALL_ANALYTIC_PERIODS(state, value) {
    state.isFetchingAllAnalyticPeriods = value
  },
  SET_LOADING_DRE_ANALYTICS_CONFIGURATIONS(state, value) {
    state.loadingAnalyticConfigurations = value
  },
}
